import { React, Container, Helper, TableColumns, DataGrid, DatePicker, DropDown } from "common";
import { UsersApi, ReportsApi } from "services";
import CollectionApi from "../popups/collection"

const DownloadColumnData = [
    { id: 1, field: "collections", apiType: 1, popText: "Do you want to download the Total Collections report for : ", filter: {} },
    { id: 2, field: "customersVisited", apiType: 1, popText: "Do you want to download the Customers Visited	 report for : ", filter: { duplicate: true } },
    { id: 3, field: "collectedAmount", apiType: 1, popText: "Do you want to download the Total Amount Collected report for : ", filter: {} },
    { id: 4, field: "assignedCollections", apiType: 2, popText: "Do you want to download the Assigned Collections report for : ", filter: {} },
    { id: 5, field: "hoVerifiedAmount", apiType: 3, popText: "Do you want to download the Verified Amount report for : ", filter: { hoverified: true } },
    { id: 6, field: "reconciledAmount", apiType: 3, popText: "Do you want to download the Reconciled Amount report for : ", filter: { reconcile: true } },
    { id: 7, field: "hoRejectedAmount", apiType: 3, popText: "Do you want to download the Rejected Amount report for : ", filter: { rejected: true } },
    { id: 8, field: "rejectedCollections", apiType: 3, popText: "Do you want to download the Rejected report for : ", filter: { rejected: true } },
    { id: 9, field: "revokedCollections", apiType: 3, popText: "Do you want to download the Revoked report for : ", filter: { revoked: true } },
]

const Component = (props) => {

    const [initialize, setInitialize] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [row, setRow] = React.useState({});
    const [agents, setAgents] = React.useState([]);
    const [isGetreport, setIsGetreport] = React.useState(false);
    const [state, setState] = React.useState(false);
    const [showPopup, setShowPopUp] = React.useState(false);
    const [seldItem, setSelItem] = React.useState("");
    const [apiData, setApiData] = React.useState({});

    const [rowsCount, setRowsCount] = React.useState(10);
    const [curPage, setCurPage] = React.useState(1);
    const [pageSize] = React.useState(10);
    const [error, setError] = React.useState(null);

    const OnGetReportClicked = (e, download) => {
        setError(null);

        if (Helper.IsNullValue(row.agentId)) {
            setError("Please select Agent");
            return;
        }

        if (Helper.IsNullValue(row.fromDate)) {
            setError("Please select From Date");
            return;
        }

        if (Helper.IsNullValue(row.toDate)) {
            setError("Please select to Date");
            return;
        }

        if (row.fromDate > row.toDate) {
            setError("Please select valid Date Range");
            return;
        }

        FilterRows(download);
    }

    const OnInputChanged = async (path, value, index) => {
        setIsGetreport(false);
        let newRow = Helper.ModifyJsonArrayObject4(row, path, value);
        setRow(newRow);
        setState(!state);

    }

    const FilterRows = async (download) => {
        setRows({});
        setIsGetreport(false);
        let filters = [];
        let _row = { ...row };
        if (_row.agentId === "All") {
            _row.agentId = AllAgentsSelected();
        } else {
            _row.agentId = [_row.agentId];
        }
        if (_row) {
            for (const key in _row) {
                if (Object.hasOwnProperty.call(_row, key) && !Helper.IsNullValue(_row[key])) {
                    filters.push({ name: key, value: _row[key] });
                }
            }
        }

        let req = { filters, environment: Helper.environment, download: download };
        global.Busy(true);
        let rslt = await ReportsApi.GetCollectionsReport(req);
        global.Busy(false);
        if (download) {
            if (rslt.status !== 100) {
                setError(rslt.statusText);
                return;
            }
            let filePath = rslt.file;
            await DownLoadExcel(filePath);
        } else {
            if (rslt.status === 100) {
                let _tmp = rslt.data;
                setRows(_tmp.rows);
                setRowsCount(_tmp.recordCount);
                setIsGetreport(true);
            }
        }
    }

    const DownLoadExcel = async (filePath) => {
        await fetch(filePath)
            .then((response) => response.blob())
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Report.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
    }

    const AllAgentsSelected = () => {
        let _Ids = agents.map((x) => {
            if (x._id !== "All") return x._id;
        }).filter(x => !Helper.IsNullValue(x));
        return _Ids;
    }

    const FetchResults = async () => {
        setAgents([]);
        let data = { page: 1, size: 99999, filters: { statusId: 1, typeId: 2 } }
        global.Busy(true);
        let rslt = await UsersApi.GetUsers(data);
        global.Busy(false);
        if (rslt.status === 100) {
            let _tmp = rslt.data.rows;
            _tmp.splice(_tmp, 0, { _id: "All", name: "All" });
            OnInputChanged('agentId', "All");
            setAgents(_tmp);
        }
    }

    const OnPageChange = async (e) => {
        setCurPage(e);
        setInitialize(true);
    }

    const OnDownLoadLinkClicked = async (e, info) => {
        e.preventDefault();
        setError(null);
        const { colName, data } = info;
        let colData = data[colName];
        if (Helper.IsEmptyOrZeroValue(colData)) return;

        let selectedItem = DownloadColumnData.find((x) => x.field.toLocaleLowerCase() === colName.toLocaleLowerCase());

        let agentInfo = agents.find((x) => x.name.toLocaleLowerCase() === data.name.toLocaleLowerCase());

        let _row = row;
        let filters = [];
        if (_row) {
            for (const key in _row) {
                if (Object.hasOwnProperty.call(_row, key) && !Helper.IsNullValue(_row[key])) {
                    if (key === "agentId") {
                        filters.push({ name: key, value: agentInfo._id });
                    } else {
                        filters.push({ name: key, value: _row[key] });
                    }
                }
            }
        }

        let req = { filters, environment: Helper.environment, download: true, agentName: agentInfo["name"], ...selectedItem.filter };

        setSelItem(selectedItem);
        setApiData(req);
        setShowPopUp(true);
    };

    const OnDownloadReportForAgent = async () => {
        let rslt;
        if (seldItem.apiType === 1) {
            global.Busy(true);
            rslt = await ReportsApi.GetCollectionsReportColl(apiData);
            global.Busy(false);
        } else if (seldItem.apiType === 2) {
            global.Busy(true);
            rslt = await ReportsApi.GetCollectionsReportAssigned(apiData);
            global.Busy(false);
        } else if (seldItem.apiType === 3) {
            global.Busy(true);
            rslt = await ReportsApi.GetCollectionsReportCo(apiData);
            global.Busy(false);
        }

        if (rslt.status !== 100) {
            setError(rslt.statusText);
            return;
        }

        let filePath = rslt.file;
        await DownLoadExcel(filePath);
    }

    const OnHideClicked = (e) => {
        setShowPopUp(false);
        if (e) {
            OnDownloadReportForAgent();
        }
    }

    if (initialize) {
        setInitialize(false);
        setShowPopUp
        FetchResults();
    }

    React.useEffect(() => {
        let _cur = curPage;
        if (curPage > 1) {
            _cur = ((curPage - 1) * pageSize) + 1;
        }
    }, [curPage, pageSize]);

    React.useEffect(() => { setInitialize(true); }, []);

    return (
        <>
            <Container {...props}>
                <div className="generic_headblk">
                    <div className="blkName">Agent Collection Data</div>
                    <div className="control_bar">
                        <div className="controlBarHeader">Select Agent:</div>
                        <div className="controlBarSelectField">
                            <DropDown
                                path={`agentId`}
                                value={row?.agentId}
                                onInputChildChanged={OnInputChanged}
                                items={agents}
                                displayName={"name"}
                                displayValue={"_id"}
                                dataRequired={false}
                                indexValue={1}
                            />
                        </div>
                        <div className="controlBarHeader">From Date:</div>
                        <div className="controlBarTxtField">
                            <DatePicker
                                id="fromDate"
                                name="fromDate"
                                value={Helper.ToString(row?.fromDate)}
                                formatDate={'DD-MM-YYYY'}
                                onInputChildChanged={OnInputChanged}
                                required={false}
                                requiredMessage={'Date is required'}
                                validation={false}
                                validationMessage={'Provide valid date'}
                                placeholder={'DD-MM-YYYY'}
                            />
                        </div>
                        <div className="controlBarHeader">To Date:</div>
                        <div className="controlBarTxtField">
                            <DatePicker
                                id="toDate"
                                name="toDate"
                                value={Helper.ToString(row?.toDate)}
                                formatDate={'DD-MM-YYYY'}
                                onInputChildChanged={OnInputChanged}
                                required={false}
                                requiredMessage={'Date is required'}
                                validation={false}
                                validationMessage={'Provide valid date'}
                                placeholder={'DD-MM-YYYY'}
                            />
                        </div>
                        <div className="mcpl_nav_btn">
                            <input type="button" value="Get Report" className="mcpl_btn"
                                onClick={(e) => OnGetReportClicked(e, false)}
                            />
                        </div>
                        <div className="mcpl_nav_btn">
                            <input type="button" value="Download Report" className="mcpl_btn"
                                onClick={(e) => OnGetReportClicked(e, true)}
                            />
                        </div>
                    </div>

                    {isGetreport &&
                        (<div className="control_bar">
                            <div className="controlBarHeader">Report From : {Helper.ToDateFormat(row?.fromDate, "DD/MM/YYYY")} to  {Helper.ToDateFormat(row?.toDate, "DD/MM/YYYY")}</div>
                        </div>
                        )}

                    {error && (
                        <ul className="mcpl_btn_blk">
                            <li className="mcpl_btn_successError" >
                                <div className="errormessage">{error}</div>
                            </li>
                        </ul>
                    )}
                </div>

                {rows && rows.length > 0 && (
                    <div className="contentarea_table">
                        <DataGrid dataColumns={TableColumns.LoanReports} onDownLoadLinkClicked={OnDownLoadLinkClicked}
                            curPage={curPage} onPageChange={OnPageChange} pageSize={pageSize} rowsCount={rowsCount} dataRows={rows} />
                    </div>
                )}
                {showPopup && <CollectionApi onHideClicked={OnHideClicked} children={seldItem.popText} agent={apiData["agentName"]} />}
            </Container>
        </>
    )
}

export default Component;